export default {
  general: {
    title: 'Future Gadget Lab',
    back: 'back'
  },
  menu: {
    topPage: 'Top Page',
    aboutLab: 'About Lab',
    futureGadget: 'Future Gadget',
    update: 'updeto'
  },
  topPage: {
    visitor: 'You\'re the {counter} visitor to this site.',
    counter: '{counter}TH',
    welcome: 'Welcome to the Future Gadget Laboratory Homepage!',
    breakingNews: 'Breaking News',
    stageOne: 'Stage 1 of expansion of the western!!!',
    futureGadget: 'Future Gadget update!',
    compatibility: 'This HOMEPAGE is compatible with deloode chrome ver.2.0 and up.',
    resolution: 'Recommended resolution is 1600x1200 pixels.',
    about: 
      `<p>
        This Paige of English is mad of efforts to expansion into west, as a
        making into perfect Engligh by glorious Super Hacka with a helping of
        machine translation software
      </p>
      <p>
        <a href="http://futuregadget-lab.com/" target="_blank">click here for main site</a>
      </p>`,
    notice: 'This is a modified version of {site} website.',
    credits: 'Coded by {name} using {vuejs}.',
    language: 'Language: {0}'
  },
  aboutPage: {
    title: 'About Lab',
    subtitle: '~Vanishment this world like nightmares is our objective us fugitives of eternity~',
    roadPage: {
      title: 'Road of procure the chaotic',
      subtitle: '~We is not to be stopped- never. Not until grab in this palm~',
      description: `
        Supreme objective (function) of Future Gadget Laboratory is "of doing invent". <br>
        By invention by his companions and mad scientist Hououin Kyouma of madness,
        do destroy the governance structure in the shadows that manipulate world,
        and in result world surely head to chaos. <br>
        It is of the selection of Door of Destiny Stone- Steins Gate. El Psy Kongroo.`
    },
    labmenPage: {
      title: 'True name\'s of those chosen',
      subtitle: '~I are, we be, RABOMEN~',
      labmenTitle: 'RABOMEN No.{number} {name}',
      laboratoryMembers: [
        {
          number: '001',
          name: 'Hououin Kyouma',
          description: 'And the founder of the Future Gadget Laboratory, mad scientist of madness.<br>' +
            'Devotion of research to bring world chaos and avoiding of attack by "Organization"!'
        }, {
          number: '002',
          name: 'Mayushii☆',
          description: 'Liking of bananas and juicy chickens number one, chief of lab\'s "making costumes (for womens only)" division.<br>' +
            'Makes an eating of somethings many times. Special ability "stardust handshake" owner.'
        }, {
          number: '003',
          name: 'Daru',
          description: 'It is SUPAHAKA that specializes in infiltration to any information network.<br>' +
            'Precious power of Hououin Kyouma\'s favorite right hand. However a perv.'
        }, {
          number: '004',
          name: '',
          description: 'Hope to finally getting of cute girl...',
          hidden: true
        }, {
          number: '65535',
          name: '',
          description: 'Just put many here',
          hidden: true
        }
      ]
    },
    strengthPage: {
      title: 'Want the strength?',
      subtitle: '~It defeat the enemy soon. It consume the self the death soon.~',
      description: `
        <br>
        In the Future Gadget Laboratory, together with repeat inventions researching,<br>
        recruiting always of researchers for fight the final crusade which one day face world.<br>
        ESP-compatible persons should make a coming to the laboratory with posthaste. This Hououin Kyouma shall make a giving of blood covenant.<br>
        Accepting the admission of followings:`,
      madScientist: 'mad scientist',
      runningFrom: 'person who is making a running from Organization',
      cosplay: 'person who can do the cosplay (man and/or woman)',
      loli: 'loli girl must have big chests'
    },
    aboutSitePage: {
      title: 'about site',
      titleWithDash: '-about site-',
      disclaimer: `
        Disclaimer items<br>
        ・Is strictly forbidden to reprinting of this site for the business.<br>
        ・Character that appears in this work, does not mean that all 18 years of age or more.<br>
        ・People, organizations, corporations that appears in this work, is part fiction, but it has nothing to do with real thing.`,
      inquiries: `
        Inquiries<br>
        ・Feedback and comments for this site please come to Chiyoda-ku, Tokyo Kuramaebashi-dori crossing Tsumakoisaka alleyway.
        There is multi-tenant building eight-story about Built '40 name "Ohiyama", there at second story.`
    }
  },
  bbsPage: {
    title: 'Phoenix BBS',
    subtitle: '(Annex of Future Gadget Laboratory)',
    returnTop: 'Return the Top',
    admin: 'Admin',
    form: {
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      comment: 'Comment',
      url: 'URL',
      password: 'Password',
      passwordInfo: '(Password for the deletion. Up to 8 characters alphanumeric)',
      submit: 'Submit',
      reset: 'Reset',
      saveCookie: 'Save the cookie information'
    },
    postedBy: 'Posted by: ',
    comments: [
      {
        subject: 'Matter of No. 7',
        name: 'Hououin Kyouma',
        date: '2010/7/13',
        comment: 'Materials cost of No. 7 alone is taking of lots of golds. It\'s being ' +
          'cheaper than now it\'s impossible. Special price of the now is already such discount.'
      }, {
        subject: 'Price',
        name: 'Phantasm Phangirl',
        date: '2010/7/13',
        comment: 'Can price of future gadgets No. 7 be made of a little cheapers?<br>' +
          'It way too expensive ｏｒｚ<br>' +
          '2000 yen is just right the pricing level.'
      }, {
        subject: 'The hell is wrong with this site?',
        name: 'Spunky',
        date: '2010/7/7',
        comment: 'This site is so lame. You\'ve got to be kidding me.<br>' +
          'I thought I went a time warp to the 90\'s for a second there.<br>' +
          'Did you seriously machine translate this crap?'
      }, {
        subject: 'lol',
        name: 'scampering bastard',
        date: '2010/6/29',
        comment: 'How chuunibyou a sight this is wwwww you funny guy Hououin-san!'
      }, {
        subject: 'Celebrity Introduction',
        name: 'Masa',
        date: '2010/6/21',
        comment: 'Looks I am liked by beauty of glasses super rich celebrity.<br>' +
          'I give the s*x to her as she asked for<br>' +
          'She say now she buying for me a new P*rsche<br>' +
          'Last month, I made an earning of more money than what core business of mine make, so I wish be pimp forever!<br>' +
          'She say friend of hers is wanting of man who make good the s*x like I make too!<br>' +
          'Sign up to score the points like me!!<br>',
        url: 'http://kusomiso.tekunikku.com/tugihashonben/'
      }, {
        subject: 'Future Gadgets',
        name: 'Hououin Kyouma',
        date: '2010/6/6',
        comment: 'Of course they for the sale. Come send fax or come directly at the lab. ' +
          'What you like? You having of any questions then we giving of details.'
      }, {
        subject: 'Future Gadgets',
        name: 'Just passing the bye',
        date: '2010/6/6',
        comment: 'Are future gadgets really for the sale? Maybe I am interested, hahah...'
      }, {
        subject: 'http://broge.deaddoo.net/pupupu/05789.html',
        name: 'Yuruyu',
        date: '2010/5/30',
        comment: 'Sorry I put link without get the permission<br>' +
          'Please make the report'
      }, {
        subject: 'College student girl a best!',
        name: 'Yujiro',
        date: '2010/5/19',
        comment: 'I maked a sexy time with sexy friend Mikitty!!<br>' +
          'She make a puff puffing with many big the boobies<br>' +
          'So moving is her shikkoshikko effort with thin finger!<br>' +
          'And plus to get money doing it I be awesome www',
        url: 'http://super.eroierokunai.net/fuhihihihi/'
      }, {
        subject: 'Commemorational proast♪',
        name: 'Mayushii☆',
        date: '2010/5/13',
        comment: 'Nice to meet you To~uuto~uru over♪ ' +
          'Is amazing to make a posting in English with automaton.'
      }, {
        subject: 'Which has set up the board',
        name: 'Hououin Kyouma',
        date: '2010/5/10',
        comment: 'English hompage of our future gadget laboratory was established finally. ' +
          'Being one chased after by the Organization, I\'d prefer the work behind a scene, but  ' +
          'I be moved by desire to leave behind a proof that "I be here". ' +
          'Yes, I want to be the found by someone... and being in English makes a widening of audience reach around. ' +
          'So in this board, I or the future gadget laboratory will make a collecting of any question whatever. ' +
          'We danube to make the answering of it. That is selection of "door over the fate - Steins gate". El Psy Kongroo.'
      }
    ],
    adminPage: {
      title: 'Phoenix BBS Admin Page',
      passwordAsking: 'Please entering of password.',
      authenticate: 'Authenticate',
      note: `
        To RABOMEN: Any fellow who forgetting of password look on paper 
        on left back of the stage on the refrigerator. Put back if look!`
    }
  },
  gadgetsPage: {
    title: 'Gadgets being of a future',
    subtitle: '~crystal of wisdom honed, it will be the fire of god in holy war~',
    description: 'The following is a number of our having been invented prestigious "the Future Gadget"',
    mailInfo: `
      We also is offer all by mail order, so make not a hesitate to do fax. If you scared of
      the regretting for products being the sold out... make a buying now.`,
    mailOrder: 'Mail order for the fax numbering: 0C-3A66-1704',
    number: 'No. {number}',
    gadgets: [
      {
        name: 'PhoneWave (provisional)',
        price: 'Price TBD',
        description: 'Microwave by combining with mobile phones has enabled remote operations. ' +
          'Warming has already been completed by time of getting home.<br>' +
          '*We is adjusting now. Not yet ready the sale'
      }, {
        name: 'Ghost in the Shell camouflage ball',
        price: 'Special price 80,000 yen',
        description: 'Big Things that you can experience the optical camouflage artificially. ' +
          'Made a makings of with 6-inch cathode-ray tube, a total of 12 units and fill the gap ' +
          'fitted with multiple ultra-compact C-MOS camera. Just, the camera are outward and ' +
          'perpendicular to the monitor of the sphere corresponding the back with that camera. ' +
          'As resulting, bind spot will disappear from this Thing, it\'s a full view from the ' +
          'other side even if hiding the shadow of Thing<br>' +
          '*Is so huge. Please order only if having enough space in the house. ' +
          'Please do not rolled then broken it.'
      }, {
        name: 'Psyllium saver',
        price: 'Special price 1,480 yen',
        description: 'Psyllium red chemical type. By installing the handle, it can also handle as sword. ' +
          'The revolutionary idea emit gore, pretending of sword fight realism it has become possible.<br>' +
          '*Please make no swinging in narrow place. There is possibility that the scattering of gore can annoying neighbors.'
      }, {
        name: 'Also by Goemon you\'ve connected the thing which is not boring',
        price: 'Special price 7,800 yen',
        description: 'Eco dryer that is electricity bill unneeded. By combined with the vacuum cleaner, ' +
          'the exhaust is being used for drier use. Mad but eco. Contradiction is conception of this anguish ' +
          'invention explosive birth here.<br>' +
          '*Drier can only use the hot air. You can not air volume control.'
      }, {
        name: 'Moaddo Snake',
        price: 'Special price 7,800 yen',
        description: 'Ultra-instant humidifier. The boiled in electric heating coil many, a large amount of water, ' +
          'it is ejected steam tremendous amount. No more needing to fear of dry season. Because it is resembling of ' +
          'claymore mine, is also useful for decoration the house.<br>' +
          '*Use for 10 square meters. This future gadget has become disposable.'
      }, {
        name: 'You mean is this oraora!?',
        price: 'Special price 9,240 yen',
        description: 'Judges lie detector depending on sweat of thumb. ' +
          'It is the best ever masterpiece which is making a possible of by all efforts combined of lab. ' +
          'All lie and all conspiracy can see through if only have this.<br>' +
          '*is a device that detects the sweating only and can not guarantee that whether penetrable a lie actually'
      }, {
        name: 'Bamboo the copter camera',
        price: 'Special price 5,480 yen',
        description: 'CCD camera of spin flier toy. When the latest AV equipment and traditional crafts of Japan is fused, ' +
          'barriers of a past and the future is disappeared, revolutionary feature called Aerial Photography by no power has been realized.<br>' +
          '*video captured is a condition which is rotating violently but is not mean that is a failure or nothing. We making no claim for this regard.'
      }, {
        name: 'Bit particle gun',
        price: 'Special price 1,098 yen',
        description: 'Thing with embedded TV remote control in the ray gun toy. By closed the trigger toward the TV, ' +
          'it is possible to switch the channel as if shooting a gun just like. Now, remember the childhood!<br>' +
          '*responsive button is "next the channel" only. For (Power, volume control, etc.) the other buttons, ' +
          'you need to work with directly at the TV main body.'
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./lang/en.js
// module id = null
// module chunks = 